import { render } from "./TheaterDashboard.vue?vue&type=template&id=27da0dbc&scoped=true"
import script from "./TheaterDashboard.vue?vue&type=script&lang=js"
export * from "./TheaterDashboard.vue?vue&type=script&lang=js"

import "./TheaterDashboard.vue?vue&type=style&index=0&id=27da0dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27da0dbc"]])

export default __exports__